import "./home.scss";
//
import TextImage from "components/textImage/textImage";
import Hero from "components/hero/hero";
import Scroll from "shell/scroll/scroll";
import IconGrid from "components/iconGrid/iconGrid";
import Footer from "components/footer/footer";
import { useRef, useState } from "react";
import { useStore } from "shell/store/store";
import VideoOverlay from "components/videoOverlay/videoOverlay";
import FeatureOverlay from "components/feature/featureOverlay";
import { AppTypes } from "shell/app/app";
import Page from "shell/page/page";
import HeroBolt from "components/hero/heroBolt";
import HeroPlanet from "components/hero/heroPlanet";
import VideoButton from "components/videoButton/videoButton";

interface homeProps extends AppTypes {}

const Home: React.FC<homeProps> = (props) => {
  const elRef = useRef<HTMLDivElement>(null);
  const [videoOpen, setVideoOpen] = useState<boolean>(false);
  //
  const language = useStore((state) => state.language);
  const data = require(`data/home.data.${language}.json`);

  return (
    <div className="home" ref={elRef}>
      <Page {...props}>
        {/* BOLT */}
        <HeroBolt />
        {/* HERO BG */}
        <HeroPlanet />
        {/* BACKGROUND  */}
        <HeroBolt />
        <div className="page-inner">
          <Scroll>
            {/* HERO */}
            <Hero {...data.hero}/>
            {/* ICONS */}
            <IconGrid {...data.features} />
            {/* VIDEO BUTTON */}
            <VideoButton {...data.hero} onVideoOpen={() => setVideoOpen(true)} />
            {/* TEXT IMAGE FOOTER */}
            <TextImage {...data.textImage} />
            {/* FOOTER */}
            <Footer />
          </Scroll>
        </div>
        {/* VIDEO OVERLAY */}
        <VideoOverlay isOpen={videoOpen} onClose={() => setVideoOpen(false)} />
        {/* FEATURE OVERLAY */}
        <FeatureOverlay {...data.features} />
      </Page>
    </div>
  );
};

export default Home;
